import { FlexColumn, LabeledData } from '@gorila-shared-ui/components';
import { Checkbox } from 'baseui/checkbox';
import { OnChangeParams } from 'baseui/select';
import { ChangeEvent } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import {
  fullReportHistoricState,
  notificationTypesState,
  reportAverageSpeedState,
  reportDistanceTraveledState,
  selectedNotificationTypeState,
} from '../../../storage/reports';
import { EnhancedLabeledSelect } from '../../ui/EnhancedLabeledSelect';

type Props = {
  assetId: string;
};

export function RouteReportInfo({ assetId }: Props) {
  const { theme } = useStyles();
  const [historic, setHistoric] = useRecoilState(fullReportHistoricState(assetId));
  const averageSpeed = useRecoilValue(reportAverageSpeedState(assetId));
  const distanceTraveled = useRecoilValue(reportDistanceTraveledState(assetId));
  const notificationTypes = useRecoilValue(notificationTypesState);
  const [selectedNotificationType, setSelectedNotificationType] = useRecoilState(
    selectedNotificationTypeState(assetId)
  );
  const onNotificationTypeChange = (params: OnChangeParams) => {
    setSelectedNotificationType(params.option?.notificationId);
  };

  const notificationTypeOptions = [
    {
      name: 'Todos',
      notificationId: undefined,
    },
    ...notificationTypes,
  ];

  if (!historic) return null;

  const onOnlyEventsChange = (event: ChangeEvent<HTMLInputElement>) => {
    setHistoric((prev) => ({ ...prev!, onlyEvents: event.target.checked }));
  };

  return (
    <FlexColumn gap={theme.sizing.scale300}>
      <FlexColumn gap={theme.sizing.scale200}>
        <LabeledData
          label={'Velocidad promedio:'}
          content={averageSpeed}
          labelWidth={'160px'}
        />
        <LabeledData
          label={'Distancia recorrida:'}
          content={distanceTraveled}
          labelWidth={'160px'}
        />
        <LabeledData
          label={'Total de posiciones:'}
          content={historic.states.length.toString()}
          labelWidth={'160px'}
        />
      </FlexColumn>
      <Checkbox
        checked={historic.onlyEvents}
        onChange={onOnlyEventsChange}
        overrides={{
          Root: {
            style: {
              alignItems: 'center',
            },
          },
          Checkmark: {
            style: {
              width: theme.sizing.scale600,
              height: theme.sizing.scale600,
            },
          },
          Label: {
            style: {
              ...theme.typography.LabelSmall,
            },
          },
        }}
      >
        Ver solo eventos
      </Checkbox>
      {historic.onlyEvents && (
        <EnhancedLabeledSelect
          label="Tipo de evento:"
          options={notificationTypeOptions}
          valueKey="notificationId"
          labelKey="name"
          onChange={onNotificationTypeChange}
          value={[{ notificationId: selectedNotificationType }]}
          inline
          inset
        />
      )}
    </FlexColumn>
  );
}
